module.exports = __webpack_public_path__ + "static/media/book.10242ce7.jpg";